export const convertFugitiveNamesToChoiceArray = hash => {
  return Object.keys(hash).map(key => {
    return {
      value: key,
      label: hash[key].display
    }
  })
}
